var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.title)?_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]):_vm._e(),_vm._v(" "),(_vm.subtitle)?_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t(_vm.subtitle)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }